import { render, staticRenderFns } from "./CollectionsIdentification.vue?vue&type=template&id=5931bb76&scoped=true"
import script from "./CollectionsIdentification.vue?vue&type=script&lang=js"
export * from "./CollectionsIdentification.vue?vue&type=script&lang=js"
import style0 from "./CollectionsIdentification.vue?vue&type=style&index=0&id=5931bb76&prod&lang=scss&scoped=true"
import style1 from "./CollectionsIdentification.vue?vue&type=style&index=1&id=5931bb76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5931bb76",
  null
  
)

export default component.exports